import React from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LocationIcon from "../../Images/location.png";

import LazyLoad from "react-lazy-load";
import "./FeaturedCard.css";

export default function FeatureCard({ property }) {
  return (
    <Card className="feature-card">
      <Box className="media-box">
        <Box alt="green iguana" className="media-image" />
        <Box className="media-box-content">
          <Stack sx={{ flexDirection: "row", gap: "10px" }}>
            <Chip label="Featured" className="media-chip-1" clickable />
            <Chip label="For Sale" className="media-chip-2" clickable />
          </Stack>

          <Box className="feature-price">
            <span>${property.price}</span>
            <small>/mo</small>
          </Box>

          <Box className="feature-icon">
            <FavoriteBorderOutlinedIcon />
          </Box>
        </Box>
      </Box>
      <CardContent>
        <Typography gutterBottom variant="body2" className="feature-type">
          Apartment
        </Typography>
        <Typography gutterBottom variant="body1" className="feature-apartment">
          {property.apartmentType} Apartment
        </Typography>
        <Stack sx={{ flexDirection: "row", gap: "10px", mt: 2, mb: 1 }}>
          <LazyLoad
            onContentVisible={() => {
              console.log("Featured Card Images Loaded!");
            }}
          >
            <img
              src={LocationIcon}
              alt="location"
              style={{ height: "20px", width: "20px" }}
            />
          </LazyLoad>
          <Typography variant="body2" color="text.secondary">
            {property.address}
          </Typography>
        </Stack>

        <Stack sx={{ flexDirection: "row", gap: "25px", mb: 2 }}>
          <Stack sx={{ flexDirection: "row", gap: "10px", my: 1 }}>
            <LazyLoad>
              <img
                src={require("../../Images/bed.png")}
                alt="location"
                style={{ height: "20px", width: "20px" }}
              />
            </LazyLoad>
            <Typography variant="body2" color="text.secondary">
              Beds: {property.beds}
            </Typography>
          </Stack>

          <Stack sx={{ flexDirection: "row", gap: "10px", my: 1 }}>
            <LazyLoad>
              <img
                src={require("../../Images/bathtub.png")}
                alt="location"
                style={{ height: "20px", width: "20px" }}
              />
            </LazyLoad>
            <Typography variant="body2" color="text.secondary">
              Baths: {property.baths}
            </Typography>
          </Stack>
        </Stack>
        <Divider sx={{ mb: 2.5 }} />

        <Button variant="contained" className="primary-button" fullWidth>
          Contact Us
        </Button>
      </CardContent>
    </Card>
  );
}
